document.addEventListener("DOMContentLoaded", function () {
  const questions = document.querySelectorAll('.ct-intro-massager-heading h2');
  const answers = document.querySelectorAll('.ct-intro-massager-title');
  const faqData = [];

  for (let i = 0; i < questions.length; i++) {
    const qText = questions[i].innerText.trim();
    const answerContainer = answers[i];
    let combinedAnswer = [];

    if (answerContainer) {
      // Go through child elements to preserve structure (p, ul, ol)
      Array.from(answerContainer.children).forEach((el) => {
        if (el.tagName === 'P') {
          const text = el.innerText.trim();
          if (text) combinedAnswer.push(text);
        } else if (el.tagName === 'UL') {
          const items = Array.from(el.querySelectorAll('li')).map(
            (li) => `• ${li.innerText.trim()}`
          );
          if (items.length) combinedAnswer.push(items.join('\n'));
        } else if (el.tagName === 'OL') {
          const items = Array.from(el.querySelectorAll('li')).map(
            (li, idx) => `${idx + 1}. ${li.innerText.trim()}`
          );
          if (items.length) combinedAnswer.push(items.join('\n'));
        }
      });
    }

    const answerText = combinedAnswer.join('\n\n'); // separate blocks by double line-break

    if (qText && answerText) {
      faqData.push({
        "@type": "Question",
        "name": qText,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": answerText
        }
      });
    }
  }

  if (faqData.length > 0) {
    const schema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": faqData
    };

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.textContent = JSON.stringify(schema).replace(/</g, "\\u003c"); // prevent XSS
    document.head.appendChild(script);
  }
});
